export const LEADSMANIA_PRODUCT_CODE = 'leadsmania' as const;
export const LEADSMANIA_PRODUCT_HEADER = 'X-Product-Code';
export const LEADSMANIA_PRODUCT_NAME = 'Лидсмания';

export type ProductCode = typeof LEADSMANIA_PRODUCT_CODE | 'tghunter' | string;

export function isLeadsmaniaProduct(productCode?: ProductCode | null) {
    return (productCode || LEADSMANIA_PRODUCT_CODE).toLowerCase() === LEADSMANIA_PRODUCT_CODE;
}

export function hasLeadsmaniaAccess(products?: ProductCode[] | null, currentProduct?: ProductCode | null) {
    if (isLeadsmaniaProduct(currentProduct)) {
        return true;
    }

    return Array.isArray(products) && products.some((product) => isLeadsmaniaProduct(product));
}
